import React from "react"
import { Card, Col, Row, Tag, Tooltip, Typography } from "antd"
import { GiSkills } from "@react-icons/all-files/gi/GiSkills"
import { skillsData } from "../../content/skillset"
import "./skills.css"

const { Title, Paragraph } = Typography
const { Meta } = Card

const Skills = () => {
  var skillContent = skillsData.skillsData
  return (
    <div style={{ backgroundColor: "#fff" }}>
      <Row style={{ paddingTop: 20 }}>
        <Col
          span={24}
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: 36,
            marginTop: 20,
          }}
        >
          <GiSkills
            style={{
              fontSize: 40,
              marginRight: 8,
            }}
          />{" "}
          <Title level={1}>MOHIT'S SKILLS</Title>
        </Col>
      </Row>
      <Row justify="center" gutter={[16, 24]}>
        {skillContent?.map(({ name, icon, alias }, i) => {
          return (
            <Col key={i} xs={12} md={6} xl={3} xxl={2}>
              <Tooltip
                placement="bottom"
                title={alias.split(",").map(a => {
                  return <Tag style={{ margin: 5 }}>{a}</Tag>
                })}
              >
                <Card
                  className="bodyPadding-0"
                  hoverable
                  bordered={false}
                  cover={
                    <div style={{ justifyContent: "center" }}>
                      <img
                        src={icon}
                        style={{ padding: 5 }}
                        height={100}
                        width={100}
                        alt={name}
                      />
                    </div>
                  }
                  style={{
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <Meta
                    title={
                      <h2 style={{ fontWeight: "bold", fontSize: 16 }}>
                        {name}
                      </h2>
                    }
                  />
                </Card>
              </Tooltip>
            </Col>
          )
        })}
      </Row>
      <Row justify="center" style={{ marginTop: 50 }}>
        <Col>
          <Paragraph>
            The Technologies listed above are only with logos found.
          </Paragraph>
        </Col>
      </Row>
    </div>
  )
}

export default Skills
